const INBOX = require('INBOX');

INBOX.namespace('classes.Contacts', function () {
    /**
     * @param {user} object
     */
    return function (client, user, limit) {
        this.page = 0;
        this.limit = limit;
        this.isLoading = false;
        this.totalCount = 0;
        this.contacts = [];
        this.client = client;
        this.user = user;
        this.searchString = null;

        this.isLastPage = function () {
            return (this.totalCount > 0 && this.totalCount <= (this.page * this.limit));
        };

        this.fetch = function (page, callback) {
            this.page = parseInt(page) || 0;
            this.isLoading = true;

            var that = this;

            this.client.getContactsWithEmail(this.user, page, this.limit, this.searchString, function (d) {
                that.totalCount = d.totalContacts;
                that.contacts = [];
                $.each(d.contacts, function (i, contact) {
                    that.contacts.push(new INBOX.classes.Contact(contact));
                });
                callback(that.contacts);
                that.isLoading = false;
            });
        };

        this.fetchNext = function (callback) {
            this.fetch(this.page + 1, callback);
        };
    };
});